import { __decorate, __metadata } from "tslib";
import { ArrayMaxSize, ArrayMinSize, IsArray, IsBoolean } from 'class-validator';
/**
 * The maximum length of a case type
 */
export const CASE_TYPE_MAX_LENGTH = 30;
/**
 * The minimum number of case types configured for the court system.
 */
export const MIN_CONFIGURABLE_CASE_TYPES = 2;
/**
 * The maximum number of case types configured for the court system.
 */
export const MAX_CONFIGURABLE_CASE_TYPES = 15;
/**
 * Enable/Disable and Configure the available case types for transcript orders
 */
export class CaseTypeConfiguration {
    /**
     * @param enabled Indicates whether case type will appear on the transcript order form
     * @param caseTypes The case types configured for the court system
     */
    constructor(enabled, caseTypes) {
        this.enabled = enabled;
        this.caseTypes = caseTypes;
    }
}
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], CaseTypeConfiguration.prototype, "enabled", void 0);
__decorate([
    IsArray(),
    ArrayMinSize(MIN_CONFIGURABLE_CASE_TYPES),
    ArrayMaxSize(MAX_CONFIGURABLE_CASE_TYPES),
    __metadata("design:type", Array)
], CaseTypeConfiguration.prototype, "caseTypes", void 0);
export const DEFAULT_CASE_TYPE_CONFIGURATION = new CaseTypeConfiguration(false, ['Criminal', 'Civil', 'Appeal']);
